$(document).on('turbo:load', function() {
  if (/preview-modal/.test(window.location.hash)) {
    return $(window.location.hash).click();
  }
});
